import React from "react";
import { Pagination } from "zina-dogi-react";
import { HotTable } from "@handsontable/react";

const ServiceOrderTable = ({ oet_ssoti, status, pagination, type_flow, ...others }) => {
    const data = getData(oet_ssoti);
    const fathersIndex = data.filter(row => row.father).map(fatherRow => data.indexOf(fatherRow));
    const table_op = {
        width: "100%",
        height: 500,
        stretchH: "all",
        settings: {
            tableClassName: ["table", "table-bordered", "table-striped"],
            fillHandle: true,
            // disableVisualSelection: true,
            wordWrap: true,
            stretchH: "none",
            className: "htCenter htMiddle",
            colHeaders: getColHeaders(status, type_flow),
            columns: getColumns(status, type_flow),
            cells: (row, col) => {
                let cellProperties = {};
                if (fathersIndex.includes(row)) {
                    let ssot_item = data[row];
                    cellProperties.className = "rowFather htLeft htMiddle";
                    if (ssot_item.cancelled) {
                        cellProperties.className = "red-father htLeft htMiddle";
                    }
                }
                return cellProperties;
            },
            data
        }
    };
    return (
        <div>
            <HotTable {...others} {...table_op} />
            <div className="row">
                <div className="col-md-4">
                    <br />
                    <span>Total {pagination.count}</span>
                </div>
                <div className="col-md-4">{pagination && <Pagination {...pagination} />}</div>
                <div className="col-md-4"></div>
            </div>
        </div>
    );
};

const getColHeaders = (status, type_flow) => {
    let res = [
        "Material item <br>number",
        "Item Description",
        "Quantity",
        ...(type_flow !== "sode_bulk" ? ["Site Id<br>Name"] : []),
        "Customer request<br>delivery date",
        "Project Request<br>delivery date",
        "Subcontractor<br>Supplier Code",
        "Subcontractor<br>Supplier",
        "Synergy",
        "SAP WBS<br>Region Description",
        "SAP WBS Zone<br>Description",
        "Site WBS<br>element",
        ...(type_flow !== "sode_bulk" ? ["WP ID", "SOG"] : []),
        "VOA Case",
        "Service task list operation",
    ];
    const cpm = [
        "Row Line<br>Number in the QC",
        "Service task list",
        "PO Release<br>Instructios",
        "Additional comment",
        "ACV ID",
        "Additional<br/>Extra Works Category",
        "VOA number",
        "VOA line item number",
        "Dummy PO",
        "Invoice Plan",
        "SvO/PO Naming",
        "Remarks",
        "JD Code"
    ];
    const omc = [
        "p20 sales_order",
        "Customer PO<br>line item number",
        "Customer PO<br>line quantity",
        "SAP service order",
        "SAP PR number",
        "SAP purchase order",
        "SVO maintenance<br>status"
    ];

    if (status >= 4) {
        res = res.concat(cpm);
    }
    if (status >= 5) {
        res = res.concat(omc);
    }
    return res;
};

const getColumns = (status, type_flow) => {
    let res = [
        {
            data: "material_code",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "description",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "quantity",
            className: "htLeft htMiddle",
            editor: false
        },
        ...(type_flow !== "sode_bulk"
            ? [
                  {
                      data: "customer_site_code",
                      className: "htLeft htMiddle",
                      editor: false
                  }
              ]
            : []),
        {
            data: "customer_request_delivery_date",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "project_request_delivery_date",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "vendor_code",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "vendor_name",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "synergy",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "sap_wbs_region_description",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "sap_wbs_zone_description",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "site_wbs_element",
            className: "htRihtLeftght htMiddle",
            editor: false
        },
        ...(type_flow !== "sode_bulk"
            ? [
                  {
                      data: "wp_id",
                      className: "htLeft htMiddle",
                      editor: false
                  },
                  {
                      data: "sog",
                      className: "htLeft htMiddle",
                      editor: false
                  }
              ]
            : []),
        {
            data: "voa_case",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "service_task_list_operation",
            className: "htLeft htMiddle",
            editor: false
        }
    ];
    const cpm = [
        {
            data: "row_line_number_qc",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "service_task_list",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "po_related_instruction",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "additional_comment",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "acv_id",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "extra_works_category",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "voa_number",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "voa_item_number",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "dummy_purchase_order",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "invoice_plan",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "spo_vo_naming",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "remarks",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "jd_code",
            className: "htLeft htMiddle",
            editor: false
        }
    ];
    const omc = [
        {
            data: "p20_sales_order",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "customer_po_line_item_number",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "customer_po_line_quantity",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "sap_service_order",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "sap_pr_number",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "sap_purchase_order",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "svo_maintenance_status",
            className: "htLeft htMiddle",
            editor: false
        }
    ];
    if (status >= 4) {
        res = res.concat(cpm);
    }
    if (status >= 5) {
        res = res.concat(omc);
    }

    return res;
};

const getData = oet_ssoti => {
    let res = [];
    if (oet_ssoti && oet_ssoti.length > 0) {
        oet_ssoti.map(item => {
            const omc = item.item_omc;
            if (omc) {
                omc.omc_id = omc.id;
                delete omc.id;
            }
            const father = {
                ...item,
                material_code: item.cost_package.code,
                voa_case: item.voa_case ? item.voa_case.name : null,
                service_task_list_operation: item.service_task_list_operation_description,
                description: item.cost_package.name,
                sap_wbs_region_description: item.site ? item.site.sap_wbs_region_description : null,
                customer_site_code: item.site ? item.site.customer_site_code : null,
                ...(omc ? omc : {}),
                synergy: item.synergy !== null ? (item.synergy ? "Synergy Partner" : "Non Synergy Partner") : null,
                father: true
            };
            delete father.site_service_order_template_item;
            res.push(father);
            if (item.ssot_items_cpm && item.ssot_items_cpm.length > 0) {
                item.ssot_items_cpm.map(ssot_item_cpm => {
                    ssot_item_cpm.cmp_id = ssot_item_cpm.id;
                    delete ssot_item_cpm.cmp_id;
                    const obj = {
                        ...father,
                        father: false,
                        ...ssot_item_cpm,
                        material_code: ssot_item_cpm.cost_package_sales_item.sales_item_code,
                        description: ssot_item_cpm.cost_package_sales_item.description,
                        quantity: ssot_item_cpm.quantity_total_cp
                    };
                    delete obj.voa_case;
                    delete obj.jd_code;
                    delete obj.remarks;
                    delete obj.spo_vo_naming;
                    delete obj.invoice_plan;
                    delete obj.voa_number;
                    delete obj.extra_works_category;
                    delete obj.po_related_instruction;
                    delete obj.acv_id;
                    delete obj.row_line_number_qc;
                    delete obj.base_id;
                    // delete obj.customer_po_line_item_number;
                    // delete obj.customer_po_line_quantity;
                    delete obj.omc_id;
                    // delete obj.p20_sales_order;
                    // delete obj.sap_pr_number;
                    // delete obj.sap_purchase_order;
                    // delete obj.sap_service_order;
                    delete obj.site_service_order_template_item;
                    delete obj.svo_maintenance_status;
                    res.push(obj);
                    return [];
                });
            }
            return [];
        });
    }
    res = res.length === 0 ? [{}] : res;
    return res;
};

export default ServiceOrderTable;
